@use '../styles/tokens' as *;

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 64px;
  background: $white;
  border-bottom: 1px solid $blue-gray-8;
  padding-right: 16px;

  @include lg {
    height: 90px;
    padding-right: 30px;
  }
}

.logoBtn {
  height: 100%;
  padding: 0;
  border: none;
  background: none;
}

.logoTile {
  svg {
    width: 60px;
    height: 60px;
  }

  @include lg {
    svg {
      width: auto;
      height: auto;
    }
  }
}

.logo {
  width: 52px;
  height: auto;
  color: $white;
}

.nav {
  display: flex;
  align-items: center;
  gap: 16px;
  color: $black;
  @include text-13;

  @include lg {
    gap: 28px;
  }
}

.navBtn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;
  border: none;
  background: none;
  color: inherit;
}

.navIcon {
  width: 20px;
  height: 20px;
}
